import { TalkJsIncomingMessageModel } from '@loavies/c2c-models'

/**
 * @param {Object} message
 * @return {loavies.models.chat.TalkJsIncomingMessageModel}
 */
export function mapTalkJsIncomingMessage(message) {
  return new TalkJsIncomingMessageModel({
    id: message.id,
    transactionId: message.conversation.id,
    attachment: message.attachment,
    timestamp: message.timestamp,
    custom: message.custom,
    origin: message.origin,
    read: message.read,
    text: message.body,
    type: message.type,
    senderId: message.senderId,
    isByMe: message.isByMe,
  })
}

/**
 * @param {loavies.models.chat.ChatModel} chat
 * @return {loavies.models.chat.TalkJsIncomingMessageModel}
 */
export function mapChatModelToTalkJsIncomingMessage(chat) {
  const talkJsChatModel = chat.talkJsChat

  return new TalkJsIncomingMessageModel({
    id: talkJsChatModel.id,
    transactionId: talkJsChatModel.id,
    attachment: talkJsChatModel.lastMessage.attachment,
    timestamp: talkJsChatModel.lastMessage.createdAt,
    custom: talkJsChatModel.lastMessage.custom,
    origin: talkJsChatModel.lastMessage.origin,
    read: false,
    text: talkJsChatModel.lastMessage.text,
    type: talkJsChatModel.lastMessage.type,
    senderId: talkJsChatModel.lastMessage.senderId,
    isByMe: false,
  })
}

